import React, { Component } from 'react'; 
import { Link } from 'react-router-dom';

class Juego extends Component{ 
    componentDidMount(){
    window.startx();
  }
    render(){ 
        return (
          <div id="main" className="wrapper style1">
            <div className="container">
              <header className="major">
                <h2>Mini Juegos</h2>
              </header>
                <div className="containerjuego"> 
                    <div className="row-juego"> 
                      <h4>En esta sección encontrarás juegos de destreza que te ayudarán a agilizar tu mente, ¡Que te diviertas!</h4>
                    </div>
                      <div className="row">
                        <div className="col-md-3">
                          <Link to="/rompecabezas">
                            <img src="images/rompecabezas.png" alt="Rompecabezas" width="70%"/>
                          </Link>
                          <h5>
                            Rompecabezas
                          </h5>
                        </div>
                        <div className="col-md-3">
                        <Link to="/frase">
                            <img src="images/frase.png" alt="Completa la Frase" width="70%"/>
                          </Link>
                          <h5>
                            Completa la Frase
                          </h5>
                        </div>

                        <div className="col-md-3">
                         <Link to="/simon">
                            <img src="images/simon.png" alt="Rompecabezas" width="70%"/>
                          </Link>
                          <h5>
                            Simon Dice
                          </h5>
                        </div> 
                     
                        <div className="col-md-3">
                          <Link to="/crucigrama">
                            <img src="images/crucigrama.png" alt="Rompecabezas" width="70%"/>
                          </Link>
                          <h5>
                            Crucigrama
                          </h5>
                        </div> 
                        
                        <div className="col-md-3">
                            <Link to="/mapa">
                            <img src="images/mapa.png" alt="Mapa Interactivo" width="70%"/>
                          </Link>
                          <h5>
                            Mapa Interactivo
                          </h5>
                        </div>
                        
                        
                        <div className="col-md-3">
                          <Link to="/palabra">
                            <img src="images/palabra.png" width="70%" alt="Portada"/>
                          </Link>
                          <h5>
                            Encuentra la Palabra
                          </h5>
                        </div>
                        

                        <div className="col-md-3">
                          <Link to="/tetris">
                            <img src="images/tetris.png" alt="Tetris" width="70%"/>
                          </Link>
                          <h5>
                            Tetris
                          </h5>
                        </div>

                        <div className="col-md-3">
                          <Link to="/sumo">
                            <img src="images/sumo.png" width="70%" alt="Portada"/>
                          </Link>
                          <h5>
                            Sumo
                          </h5>
                        </div>

                        <div className="col-md-3">
                          <Link to="/fisica">
                            <img src="images/juegafisica.png" width="70%" alt="Portada"/>
                          </Link>
                          <h5>
                            Juega con la Fisica
                          </h5>
                        </div>
                        {/* <div className="col-md-3">
                          <a href="/dk" target=""> <img src="images/dk.png" width="70%" alt="Portada"/></a>
                          <h5>
                            Donkey Kong Country
                          </h5>
                        </div>
                         <div className="col-md-3">
                          <a href="/smk" target=""> <img src="images/smk.png" width="70%" alt="Portada"/></a>
                          <h5>
                            Super Mario Kart
                          </h5>
                        </div>
                        <div className="col-md-4">
                          <a href="/rompecabezas" target=""> <img src="images/pic01.jpg" alt="Portada"/></a>
                          <h5>
                            Sopa de Letras
                          </h5>
                        </div> */}
                      </div>
                </div>
            </div>
            </div>
          
        ); 
    } 
} 

export default Juego;